import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from '@angular/router';
import { SessionStorageService, StoreKey } from 'src/app/core/layout/session-storage.service';

export interface BottomNavItem {
  text: string;
  iconPath: string;
  iconName: string;
  iconActivePath: string;
  url: string;
}

@Component({
  selector: 'app-bottom-nav',
  templateUrl: './bottom-nav.component.html',
  styleUrls: ['./bottom-nav.component.css']
})
export class BottomNavComponent implements OnInit {
  selectedId: number = 0;
  navItems: BottomNavItem[] = [
    {
      text: 'ホーム',
      iconPath: 'assets/images/icon/layout/home.svg',
      iconName: 'nav-icon-home',
      iconActivePath: 'assets/images/icon/layout/home-active.svg',
      url: '/patient/new-list'
    },
    {
      text: '設定',
      iconPath: 'assets/images/icon/layout/setting.svg',
      iconName: 'nav-icon-setting',
      iconActivePath: 'assets/images/icon/layout/setting-active.svg',
      url: '/setting'
    },
  ];

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private router: Router,
    private sessionService: SessionStorageService,
  ) {
    // カスタムのsvgファイルをmat-iconとして使うため
    for (var navItem of this.navItems) {
      this.matIconRegistry.addSvgIcon(
        navItem.iconName,
        this.domSanitizer.bypassSecurityTrustResourceUrl(navItem.iconPath)
      );
      this.matIconRegistry.addSvgIcon(
        navItem.iconName + '-active',
        this.domSanitizer.bypassSecurityTrustResourceUrl(navItem.iconActivePath)
      );
    }
    sessionService.nav$.subscribe((id: number) => {
      this.selectedId = id;
      // SessionStorage中の選択状態を更新する
      this.sessionService.set(StoreKey.I, this.selectedId);
    });
  }

  ngOnInit(): void {
    // SessionStorage中の選択状態を取得する（旧3タブ構成: 0=ホーム 1=患者 2=設定 → 現行2タブに合わせる）
    const raw = this.sessionService.get(StoreKey.I);
    if (raw.length > 0) {
      let id = +raw;
      if (Number.isNaN(id)) {
        id = 0;
      } else if (id === 1) {
        id = 0;
      } else if (id >= 2) {
        id = 1;
      } else if (id < 0) {
        id = 0;
      }
      this.selectedId = id;
      this.sessionService.set(StoreKey.I, this.selectedId);
    }
  }

  changeRoute(id: number): void {
    // SessionStorage中の展開状態を更新する
    if (this.selectedId === id) {
      this.redirectTo(this.navItems[id].url);
    } else {
      this.selectedId = id;
      // SessionStorage中の選択状態を更新する
      this.sessionService.set(StoreKey.I, this.selectedId);
      this.router.navigate([this.navItems[id].url]);
    }
  }

  /**
   * 同じアイコンを押下後、画面をリロードするために、一時的にリダイレクト
   */
  redirectTo(uri: string): void {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(
      () => this.router.navigate([uri])
    );
  }

}
